module.exports = __webpack_public_path__ + "img/search-bulb.7f16a05.svg";